(function () {
  'use strict';

  if (window.VermolaWishlist) return;

  var STORAGE_KEY = 'vermola_wishlist_v1';
  var toastTimer = null;

  function showToast(message, added) {
    var toast = document.querySelector('[data-vr-wishlist-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'vr-wishlist-toast';
      toast.setAttribute('data-vr-wishlist-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="vr-wishlist-toast__icon" aria-hidden="true"></span><span data-vr-wishlist-toast-text></span>';
      document.body.appendChild(toast);
    }

    var text = toast.querySelector('[data-vr-wishlist-toast-text]');
    if (text) text.textContent = message;
    toast.classList.toggle('is-added', Boolean(added));
    toast.classList.remove('is-visible');
    window.clearTimeout(toastTimer);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    });
    toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  function read() {
    try {
      var value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function write(handles) {
    var clean = Array.from(new Set(handles.filter(Boolean)));
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(clean)); } catch (error) {}
    document.dispatchEvent(new CustomEvent('vermola:wishlist-change', { detail: { handles: clean } }));
    updateUi(clean);
    return clean;
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var handles = read();
    var index = handles.indexOf(handle);
    if (index === -1) handles.push(handle);
    else handles.splice(index, 1);
    write(handles);
    return index === -1;
  }

  function updateUi(handles) {
    handles = handles || read();
    document.querySelectorAll('[data-vr-wishlist-count]').forEach(function (count) {
      count.textContent = handles.length;
      count.classList.toggle('is-visible', handles.length > 0);
    });

    document.querySelectorAll('[data-vr-wishlist-toggle]').forEach(function (button) {
      var selected = handles.indexOf(button.dataset.productHandle) !== -1;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-label', selected ? 'Remove from wishlist' : 'Add to wishlist');
      var label = button.querySelector('[data-vr-wishlist-label]');
      if (label) label.textContent = selected ? (button.dataset.removeText || 'Saved') : (button.dataset.addText || 'Add to wishlist');
    });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency;
    }
  }

  function productCard(product, labels) {
    var variant = (product.variants || []).find(function (item) { return item.available; }) || product.variants[0];
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var price = variant ? variant.price : product.price;
    var compare = variant ? variant.compare_at_price : product.compare_at_price;
    var isSale = compare && compare > price;
    var url = product.url || ('/products/' + product.handle);
    var needsOptions = (product.variants || []).length > 1;

    return '<article class="vr-wishlist-card" data-vr-wishlist-card="' + escapeHtml(product.handle) + '">' +
      '<a class="vr-wishlist-card__media" href="' + escapeHtml(url) + '">' +
        (image ? '<img class="vr-wishlist-card__image" src="' + escapeHtml(image) + '&width=800" alt="' + escapeHtml(product.title) + '" width="800" height="1000" loading="lazy">' : '') +
      '</a>' +
      '<button class="vr-wishlist-card__remove" type="button" data-vr-wishlist-remove="' + escapeHtml(product.handle) + '" aria-label="' + escapeHtml(labels.remove) + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.2-4.35-9.45-8.36C.67 9.3 2.08 5.25 5.77 4.36 8.02 3.82 10.1 4.7 12 6.7c1.9-2 3.98-2.88 6.23-2.34 3.69.89 5.1 4.94 3.22 8.28C19.2 16.65 12 21 12 21Z"/></svg>' +
      '</button>' +
      '<div class="vr-wishlist-card__body">' +
        '<a class="vr-wishlist-card__title" href="' + escapeHtml(url) + '">' + escapeHtml(product.title) + '</a>' +
        '<div class="vr-wishlist-card__price' + (isSale ? ' vr-wishlist-card__price--sale' : '') + '">' +
          '<span>' + money(price) + '</span>' +
          (isSale ? '<span class="vr-wishlist-card__compare">' + money(compare) + '</span>' : '') +
        '</div>' +
        (needsOptions
          ? '<a class="vr-wishlist-card__button" href="' + escapeHtml(url) + '">' + escapeHtml(labels.choose) + '</a>'
          : '<button class="vr-wishlist-card__button" type="button" data-vr-wishlist-add-cart data-variant-id="' + (variant ? variant.id : '') + '"' + ((!variant || !variant.available) ? ' disabled' : '') + '>' + escapeHtml((variant && variant.available) ? labels.add : labels.soldOut) + '</button>') +
      '</div>' +
    '</article>';
  }

  async function renderPage(root) {
    var grid = root.querySelector('[data-vr-wishlist-grid]');
    var status = root.querySelector('.vr-wishlist-status');
    var empty = root.querySelector('[data-vr-wishlist-empty]');
    var loading = root.querySelector('[data-vr-wishlist-loading]');
    var handles = read();
    var labels = {
      add: root.dataset.addText || 'Add to cart',
      choose: root.dataset.chooseText || 'Choose options',
      added: root.dataset.addedText || 'Added',
      soldOut: root.dataset.soldOutText || 'Sold out',
      remove: root.dataset.removeText || 'Remove from wishlist'
    };

    grid.innerHTML = '';
    empty.classList.remove('is-visible');
    if (!handles.length) {
      status.hidden = false;
      loading.hidden = true;
      empty.classList.add('is-visible');
      return;
    }

    status.hidden = false;
    loading.hidden = false;
    var products = await Promise.all(handles.map(async function (handle) {
      try {
        var response = await fetch('/products/' + encodeURIComponent(handle) + '.js');
        if (!response.ok) return null;
        return await response.json();
      } catch (error) { return null; }
    }));

    var validProducts = products.filter(Boolean);
    var validHandles = validProducts.map(function (product) { return product.handle; });
    if (validHandles.length !== handles.length) write(validHandles);
    loading.hidden = true;
    grid.innerHTML = validProducts.map(function (product) { return productCard(product, labels); }).join('');
    if (!validProducts.length) empty.classList.add('is-visible');
    else status.hidden = true;
  }

  function renderAllPages() {
    document.querySelectorAll('[data-vr-wishlist-page]').forEach(renderPage);
  }

  document.addEventListener('click', async function (event) {
    var toggleButton = event.target.closest('[data-vr-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      var addedToWishlist = toggle(toggleButton.dataset.productHandle);
      if (toggleButton.classList.contains('vr-wishlist-button--product')) {
        showToast(addedToWishlist ? 'Added to your wishlist' : 'Removed from your wishlist', addedToWishlist);
      }
      return;
    }

    var removeButton = event.target.closest('[data-vr-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      toggle(removeButton.dataset.vrWishlistRemove);
      renderAllPages();
      return;
    }

    var addButton = event.target.closest('[data-vr-wishlist-add-cart]');
    if (addButton && !addButton.disabled) {
      event.preventDefault();
      addButton.disabled = true;
      var original = addButton.textContent;
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(addButton.dataset.variantId), quantity: 1 })
        });
        if (!response.ok) throw new Error('Cart request failed');
        var page = addButton.closest('[data-vr-wishlist-page]');
        addButton.textContent = page ? (page.dataset.addedText || 'Added') : 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      } catch (error) {
        addButton.textContent = original;
        addButton.disabled = false;
      }
    }
  });

  document.addEventListener('vermola:wishlist-change', renderAllPages);
  document.addEventListener('shopify:section:load', function () { updateUi(); renderAllPages(); });

  function init() { updateUi(); renderAllPages(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.VermolaWishlist = { read: read, has: has, toggle: toggle, render: renderAllPages };
})();
